import EventDetailHome from '@/screens/EventDetailHome';

export default function PrivateTabsEventEventIdIndexRoute() {
  return (
    <EventDetailHome
      basePath="/event/[eventId]"
      teamMemberPathname="/event/team/member/[personId]"
    />
  );
}
